export default __webpack_public_path__ + "static/media/saucelabs.7a7d2c2b.svg";